module.exports = __webpack_public_path__ + "img/Report.1b328af6.svg";